import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { AccountAction } from 'dashboard/models/account-action';
import { TriggerAccount } from 'dashboard/models/trigger';
import { WorkflowStatus } from 'dashboard/models/workflow';
import { WorkflowVersion } from 'dashboard/models/workflow-version';
import Action from 'lib/interfaces/Action';

export type AccountActionsActions =
  | Action<AccountActionsActionType.SetAccountActions, SetAccountActionsPayload>
  | Action<AccountActionsActionType.SetActionWorkflowVersions, SetActionWorkflowVersionsPayload>
  | Action<AccountActionsActionType.SetTriggers, SetTriggersPayload>
  | Action<AccountActionsActionType.SetFilters, SetFiltersPayload>
  | Action<AccountActionsActionType.SetSortParams, SetSortParamsPayload>;

export enum AccountActionsActionType {
  SetAccountActions = 'account-actions/SET_ACCOUNT_ACTIONS',
  SetActionWorkflowVersions = 'account-actions/SET_ACTION_WORKFLOW_VERSIONS',
  SetTriggers = 'account-actions/SET_TRIGGERS',
  SetFilters = 'account-actions/SET_FILTERS',
  SetSortParams = 'account-actions/SET_SORT_PARAMS',
}

export interface AccountActionsFilterParams {
  status?: WorkflowStatus[];
  omni?: string;
}

interface SetAccountActionsPayload {
  accountActions: AccountAction[];
}

export function setAccountActions(
  accountActions: AccountAction[],
): Action<AccountActionsActionType.SetAccountActions, SetAccountActionsPayload> {
  return {
    payload: {
      accountActions,
    },
    type: AccountActionsActionType.SetAccountActions,
  };
}

interface SetActionWorkflowVersionsPayload {
  actionWorkflowVersions: WorkflowVersion[];
}

export function setAccountActionVersions(
  actionWorkflowVersions: WorkflowVersion[],
): Action<AccountActionsActionType.SetActionWorkflowVersions, SetActionWorkflowVersionsPayload> {
  return {
    payload: {
      actionWorkflowVersions,
    },
    type: AccountActionsActionType.SetActionWorkflowVersions,
  };
}

interface SetTriggersPayload {
  triggers: TriggerAccount[];
}

export function setTriggers(
  triggers: TriggerAccount[],
): Action<AccountActionsActionType.SetTriggers, SetTriggersPayload> {
  return {
    payload: {
      triggers,
    },
    type: AccountActionsActionType.SetTriggers,
  };
}

interface SetFiltersPayload {
  filters: AccountActionsFilterParams;
}

export function setFilters(
  filters: AccountActionsFilterParams,
): Action<AccountActionsActionType.SetFilters, SetFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: AccountActionsActionType.SetFilters,
  };
}

interface SetSortParamsPayload {
  sortParams: SortParams;
}

export function setSortParams(
  sortParams: SortParams,
): Action<AccountActionsActionType.SetSortParams, SetSortParamsPayload> {
  return {
    payload: {
      sortParams,
    },
    type: AccountActionsActionType.SetSortParams,
  };
}
